import React, { FC } from 'react';
import { RefundPricesFragment } from '@websky/graphql';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import ElementsPriceDetails from '../../../../ElementsPriceDetails/ElementsPriceDetails';
import { useTheme } from '../../../../../theme';
import PriceItem from '../PriceItem/PriceItem';
import { isFareOrServicesNotEmpty, isRetentionNotEmpty } from '../../utils';
import TotalRefund from '../TotalRefund/TotalRefund';

interface Props {
	prices: RefundPricesFragment;
	className?: string;
}

const Details: FC<Props> = ({ prices, className }) => {
	const { t } = useTranslation('Refund');
	const { Details: css } = useTheme('PriceDetails');

	return (
		<div className={cn(css.root, className)}>
			<TotalRefund className={css.totalRefund} price={prices.priceToPay} />

			<ElementsPriceDetails elements={prices.priceDetails.refunded} />
			{isFareOrServicesNotEmpty(prices.priceDetails.refunded) && <div className={css.dashedSeparator} />}

			<PriceItem
				name={t('Total has been paid')}
				className={css.priceHeadTitle}
				price={prices.priceDetails.paid.sum}
			/>
			<div className={css.dashedSeparator} />

			{isRetentionNotEmpty(prices) && (
				<>
					<div className={css.priceHeadTitle}>{t('Retentions')}</div>
					<ElementsPriceDetails elements={prices.priceDetails.retention} />
					<div className={css.dashedSeparator} />
				</>
			)}

			<PriceItem
				name={t('Non refundable sum')}
				className={css.priceHeadTitle}
				price={{
					...prices.priceDetails.paid.sum,
					amount: prices.priceDetails.paid.sum.amount - prices.priceToPay.amount * -1
				}}
			/>
		</div>
	);
};

export default Details;
